import getters from './getters';
import state from './state';
import actions from './actions';
import mutations from './mutations';

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};
